import { AxiosResponse } from 'axios'
import { requests } from '.'
import config from '../config'

interface GetFunnelStatsParams {
	funnelId: string
	fromDate: string
	toDate: string
	stepId?: string
	controlPageUrl?: string
	variationPageUrl?: string
  }

  interface ResetFunnelStatsParams {
	funnelId: string
  }
  

const StatsServices = {
	getFunnelStats: (params:GetFunnelStatsParams) =>
		requests(config.statsApiURL).get(`/stats/`, { params }),
	resetFunnelStats: (params:ResetFunnelStatsParams) =>
		requests(config.statsApiURL).post(`/stats/reset/`, params),
}

export default StatsServices
